<telxl-shared-overlay-modal size="lg">
    <ng-template #modalHeader>
        <header
            class="d-flex justify-content-between align-items-center w-100"
            aria-label="Upload Modal Header"
        >
            <h2 class="font-lg weight-medium px-2 pt-2 mb-0">Attachments</h2>

            <telxl-button
                colour="secondary"
                size="lg"
                (buttonClick)="close()"
                (keydown.enter)="close()"
            >
                <i class="fa-light fa-lg fa-xmark"></i>
            </telxl-button>
        </header>
    </ng-template>

    <ng-template #modalBody>
        <div class="scroll-container mt-2">
            @for (file of files(); track file.id) {
                <telxl-shared-single-attachment [file]="file" />
            }
        </div>
    </ng-template>
</telxl-shared-overlay-modal>
